import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsArloComponent } from './simple-icons-arlo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsArloComponent ],
    exports:      [ SimpleIconsArloComponent ],
    bootstrap:    []
})
export class SimpleIconsArloModule {}
